import { render, staticRenderFns } from "./OpenItems.vue?vue&type=template&id=61723682&scoped=true&"
import script from "./OpenItems.vue?vue&type=script&lang=js&"
export * from "./OpenItems.vue?vue&type=script&lang=js&"
import style0 from "./OpenItems.vue?vue&type=style&index=0&id=61723682&lang=scss&scoped=true&"
import style1 from "./OpenItems.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61723682",
  null
  
)

export default component.exports